import {post} from '../Services/http';
import { catchError } from './Error.action';
// import { show as showNotification } from './Notification.action';


export const PRICELIST_RECEIVE = 'PRICELIST_RECEIVE';
export const PRICELIST_ERROR = 'PRICELIST_ERROR';


export const pricelistadd = ({nodeIdToShowNotification = null, notificationMessage = null, hash = ''}) => {
    return (dispatch) => {
       
        return post('api/pricelist/getpricelist')
      //  return post('/api/cart/bulkinsert', { Productlist: productlistarr })
            .then(response => response.json())
            .then(result => {
             
                //var path = location.protocol + '//' + location.host + result.exportlink; 
                //result.exportlink=path;
                dispatch(receive(result));
               
                //upgrade if(result.isSuccess){
                // nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                
                
                // }
            })
            .catch(ex => dispatch(catchError(ex, error => setError(error))));
    }
}

export const pricelistcheck = () => {
    return (dispatch) => {
       
        return post('api/pricelist/checkpricelist')
            .then(response => response.json())
            .then(result => {
             if( result.exportlink!=null &&  result.exportlink!=""){
                var path = location.protocol + '//' + location.host + result.exportlink;
                result.exportlink=path; 
             }
                dispatch(receive(result));
            })
            .catch(ex => dispatch(catchError(ex, error => setError(error))));
    }
}
const receive = (result) => (
    {
    type: PRICELIST_RECEIVE,
    payload: {
        result,
    },
})
export const setError = error => ({
    type: PRICELIST_ERROR,
    payload: {
        error,
    },
})


